import { CalendarDaysIcon, UserCircleIcon } from "@heroicons/react/20/solid";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faAddressCard } from "@fortawesome/free-regular-svg-icons";
import { faTag } from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";
import { Avatar } from "../atoms/Avatar";

const Stacked = () => {
  return (
    <div className="lg:col-start-1 lg:row-end-1">
      <h2 className="sr-only">title</h2>
      <div className="rounded-lg bg-gray-50 shadow-sm ring-1 ring-gray-900/5">
        <dl className="flex flex-wrap">
          <div className="px-4 pt-6">
            <Avatar src="https://picsum.photos/500" size="extraLarge"></Avatar>
          </div>
          <div className="flex-none self-end pr-4 pt-4">
            <dd className="px-2 py-1 text-xl font-medium text-gray-700 break-words">
              Andres Felipe Florian
            </dd>
          </div>
          <div className="mt-6 flex w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
            <dt className="flex-none">
              <span className="sr-only">Client</span>
              <UserCircleIcon
                aria-hidden="true"
                className="h-6 w-5 text-gray-400"
              />
            </dt>
            <dd className="text-sm font-medium leading-6 text-gray-900">
              afloriangonzales@gmail.com
            </dd>
          </div>
          <div className="mt-4 flex w-full flex-none gap-x-4 px-6">
            <dt className="flex-none">
              <span className="sr-only">Due date</span>
              <CalendarDaysIcon
                aria-hidden="true"
                className="h-6 w-5 text-gray-400"
              />
            </dt>
            <dd className="text-sm leading-6 text-gray-500">
              <time dateTime="2023-01-31">
                {t("lead.views.registered")}: January 31, 2023
              </time>
            </dd>
          </div>
          <div className="mt-4 flex w-full flex-none gap-x-4 px-6">
            <dt className="flex-none">
              <span className="sr-only">Status</span>
              <FontAwesomeIcon
                aria-hidden="true"
                className="h-5 w-5 text-gray-400"
                icon={faAddressCard}
              />
            </dt>
            <dd className="text-sm leading-6 text-gray-500">ID: 123456789</dd>
          </div>
        </dl>
        <div className="mt-6 border-t border-gray-900/5 px-6 py-6 flex items-center ">
          <a href="#" className="text-sm font-semibold leading-6 text-gray-900">
            <span aria-hidden="true">
              <FontAwesomeIcon
                aria-hidden="true"
                className="h-5 w-5 text-gray-400"
                icon={faTag}
              />
            </span>
          </a>
          <div className="pl-4 flex">
            <p className="text-sm leading-6 text-gray-500 mr-4"> Marketing: </p>
            <span
              className={`inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium ring-purple-600/20 text-purple-700 ring-1 ring-inset background `}
            >
              estado
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stacked;
